import React, { Component } from 'react'

import {
	isMobile,
	formatByTimeZone,
	safelyFormatText,
	getOnlineDotProps
} from 'utils'

import linkifyHtml from 'linkifyjs/html'

import ProfilePicture from 'components/profile/profile-picture'

import isEqual from 'react-fast-compare'
import MessageGroupMessage from './message-group-message'
import MessageGroupFile from './message-group-file'

export default class MessageGroup extends Component {
	shouldComponentUpdate = nextProps => {
		// both of these are tiny, it's okay.
		if (isEqual(this.props.messageGroup, nextProps.messageGroup) && isEqual(this.props.currentlyEditedComment, nextProps.currentlyEditedComment)) {
			return false
		}

		return true
	}

	formatMessageDate = date => {
		const dateMoment = formatByTimeZone(date, null, true)
		const isCurrentYear = dateMoment.year() === formatByTimeZone(null, null, true).year()

		return dateMoment.format(isCurrentYear ? 'Do MMMM, h:mm a' : 'Do MMMM YYYY, h:mm a')
	}

	formatText = text => {
		if (!text) {
			return ''
		}

		let messageText = text.replace('<p></p>', '')
		messageText = messageText.replace('<p><br></p>', '')

		if (!messageText) {
			return ''
		}

		try {
			messageText = linkifyHtml(messageText, {})
		}catch(e){
			console.log(e)
		}

		messageText = safelyFormatText(messageText)

		messageText = messageText.replace(/ href/g, ' target="_blank" href')
		messageText = messageText.replace(/_self/g, '_blank')

		return messageText
	}

	render() {
		const {
			messageGroup,
			thisUser,
			processUploadData,
			getUserName,
			openPreviewModal,
			type,
			isGroup,
			incrementVersionsRenderedData,
			allUsers,
			onlineUsers,
			isArchived,
			contentRefs,
			handleEditCommentChange,
			currentlyEditedComment,
			likeEntity,
			editComment,
			deleteComment,
			saveEditedComment,
			cancelEditComment,
			replyEntity,
			handleMessageItemMountOrLoad,
			activeSearchResultObject
		} = this.props

		let isMine = false
		const user = messageGroup.user

		const lastMessage = messageGroup.messages[(messageGroup.messages.length - 1)]

		let seenData = null

		if (!user) {
			return null
		}

		if (user && user.id == thisUser.id) {
			isMine = true
		}

		const userDotProps = isGroup ? getOnlineDotProps(user, onlineUsers.find(onlineUser => onlineUser.id === user.id)) : null

		const seenIds = lastMessage.seen_by ? [...lastMessage.seen_by] : []

		const showSeenString = lastMessage.sender_id == thisUser.id && seenIds.find(id => {
			return id !== thisUser.id
		})

		if (showSeenString) {
			seenData = {
				label: 'Seen',
				tooltip: `Seen by `
			}

			const idsNotMine = seenIds.filter(id => id !== thisUser.id)

			const seenUsers = idsNotMine.map(id => allUsers[id]).filter(Boolean)

			seenUsers.forEach((seenUser, index) => {
				const isLast = index === seenUsers.length - 1

				if (index) {
					if (!isLast) {
						seenData.tooltip += ', '
					} else {
						seenData.tooltip += ' and '
					}
				}

				const hasOtherUserWithName = seenUsers.find(_seenUser => _seenUser.first_name === seenUser.first_name && _seenUser.id !== seenUser.id)

				seenData.tooltip += seenUser.first_name

				if (hasOtherUserWithName) {
					seenData.tooltip += seenUser.first_name + ' ' + seenUser.last_name.charAt(0)
				}
			})
		}

		// the below is just for uploads
		let newFiles = []
		let updatedFiles = []

		let description

		if (messageGroup.isUpload) {
			let uploadData = processUploadData(messageGroup)

			description = uploadData.description
			newFiles = uploadData.newFiles
			updatedFiles = uploadData.updatedFiles
		}

		let className = 'clear'

		if (isMine) {
			className += ' mine'
		}

		if (messageGroup.isReply) {
			className += ' reply'
		}

		const commonFileProps = {
			incrementVersionsRenderedData,
			openPreviewModal,
			handleMessageItemMountOrLoad,
			type,
		}

		const commonMessageGroupProps = {
			isMine,
			type,
			allUsers,
			formatText: this.formatText,
			getUserName,
			contentRefs,
			handleEditCommentChange,
			handleMessageItemMountOrLoad,
			currentlyEditedComment,
			likeEntity,
			editComment,
			isArchived,
			thisUser,
			deleteComment,
			saveEditedComment,
			cancelEditComment,
			replyEntity,
			isGroup,
			user
		}

		return (
			<li className={className}>
				{(type !== 'message' || (!isMine && !isMobile())) ?
					<div className="tooltip-trigger">
						{userDotProps && <em {...userDotProps} />}
						<ProfilePicture user={user} isTiny={true} />
						<div className="tooltip">
							{user.first_name}
						</div>
					</div>
					: null}
				<div className="group-messages">
					{
						type === 'comment' &&
						<div className="message-meta">
							<strong>
								{
									user ?
										`${user.first_name} ${user.last_name}`
										:
										'Deleted user'
								}
							</strong>
							<span>
								{this.formatMessageDate(messageGroup.startDateTime)}
							</span>
						</div>
					}
					{
						messageGroup.isUpload ?
							<div className="message-content file">
								{type === 'comment' &&
									<span>
										{description}
									</span>
								}
								{
									(isMobile() && user.id !== isMine && isGroup && type === 'message') &&
									getUserName(user)
								}
								{[newFiles, updatedFiles].map((fileGroup, fileGroupIndex) => {
									if (!fileGroup.length) {
										return null
									}

									return (
										<div
											className="file-container-group"
											key={fileGroupIndex}
										>
											{fileGroup.map((version, index) => (
												<MessageGroupFile
													key={index}
													version={version}
													{...commonFileProps}
												/>
											))}
										</div>
									)
								})}
							</div>
							:
							<div>
								{messageGroup.messages.map((message, index) => {
									const response = (
										<MessageGroupMessage
											key={index}
											index={index}
											message={message}
											isActiveSearchResult={message.isSearchResult ? activeSearchResultObject.term : false}
											{...commonMessageGroupProps}
										/>
									)

									if (type === 'message' && message.replyingTo) {
										return (
											<div key={index} className={'reply-container'}>
												<div className='original'>
													<MessageGroupMessage
														index={index}
														message={message.replyingTo}
														isReply
														{...commonMessageGroupProps}
													/>
												</div>
												<div className='response'>
													<MessageGroupMessage
														index={index}
														message={message}
														isActiveSearchResult={message.isSearchResult ? activeSearchResultObject.term : false}
														{...commonMessageGroupProps}
													/>
												</div>
											</div>
										)
									}

									return response
								})}
							</div>
					}
					{
						type == 'message' &&
						<div
							className={`last-message-time ${seenData ? 'tooltip-trigger' : ''}`}
						>
							{formatByTimeZone(messageGroup.messages[(messageGroup.messages.length - 1)].created_at, 'h:mm a')}
							{seenData ? ' • ' + seenData.label : null}
							{seenData ?
								<div className='tooltip top-right'>
									{seenData.tooltip}
								</div>
								: null}
						</div>
					}
				</div>
			</li>
		)
	}
}
